var React = require('react');

function Hamburger (props) {
    return React.createElement("svg",props,React.createElement("path",{"d":"M10.1666 15.25H50.8333V20.3333H10.1666V15.25ZM20.3333 27.9583H50.8333V33.0417H20.3333V27.9583ZM33.0416 40.6667H50.8333V45.75H33.0416V40.6667Z","fill":"black"}));
}

Hamburger.defaultProps = {"width":"61","height":"61","viewBox":"0 0 61 61","fill":"none"};

module.exports = Hamburger;

Hamburger.default = Hamburger;
